var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OTTRequestMessage } from '@shared/utils/DirectMessages/ExternalLink/OTTRequestMessage';
import { BaseExtLink } from './BaseExtLink';
import { BrandingToolLinkGenerator } from './Branding/BrandingToolLinkGenerator';
import { Connection } from '../../Connection';
import { ResourcesManager } from '../../properties/ResourcesManager';
export class TokenPostExtLink extends BaseExtLink {
    constructor() {
        super();
        this.isOpenWithPost = true;
    }
    getPostData() {
        return __awaiter(this, void 0, void 0, function* () {
            const oneTimeToken = yield this.getOneTimeToken();
            return {
                token: oneTimeToken,
                theme: 'night',
                language: ResourcesManager.getLanguageTag(),
                platform: 'TraderEvolution'
            };
        });
    }
    generateUrl() {
        const url = BrandingToolLinkGenerator.generateLinkNoneURL(this);
        if (url !== null) {
            this.url = url;
            if (this.updateValue) {
                this.updateValue(url);
            }
        }
    }
    getOneTimeToken() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const ottRequest = new OTTRequestMessage();
            ottRequest.externalId = this.id;
            const ottResponse = yield Connection.sendOutputMessageAsync(ottRequest);
            return (_a = ottResponse === null || ottResponse === void 0 ? void 0 : ottResponse.oneTimeToken) !== null && _a !== void 0 ? _a : null;
        });
    }
}
